<template>
    <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h4>{{ $t('aube-coin.staking.titleRemittance') }}</h4>
        </div>

        <form @submit.prevent="handleOnSubmit" class="text-center">
            <div class="box">
                <div class="wrap">
                    <div class="condition">
                        <!-- Forthing送金設定 -->
                        <div class="setting-box flex">
                            <div>
                                <label class="setting-title" v-html="$t('aube-coin.staking.forthingSettingTitle')"></label>
                            </div>
                            <div class="colon">:</div>
                            <div class="left">
                                <template v-for="option in forthingOptions">
                                    <div>
                                        <input
                                            :key="'forthing_input_' + option.value"
                                            type="radio"
                                            name="aube_coin_forthing_setting"
                                            :id="'forthing_' + option.value"
                                            :value="option.value"
                                            v-model="formData.aube_coin_forthing_setting"
                                            :disabled="disabled_flg && Number(formData.aube_coin_forthing_setting) !== option.value"
                                        >
                                        <label
                                            :key="'forthing_label_' + option.value"
                                            class="value-title"
                                            :for="'forthing_' + option.value"
                                        >
                                            {{ $t(option.label) }}
                                        </label>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="showRemittanceBonusSetting" class="box">
                <div class="wrap">
                    <div class="condition">
                        <!-- EX BONUS送金設定 -->
                        <div class="setting-box flex">
                            <div>
                                <label class="setting-title" v-html="$t('aube-coin.staking.exBonusSettingTitle')"></label>
                            </div>
                            <div class="colon">:</div>
                            <div class="left">
                                <template v-for="option in exBonusOptions">
                                    <div class="">
                                        <input
                                            :key="'exbonus_input_' + option.value"
                                            type="radio"
                                            name="aube_coin_ex_bonus_setting"
                                            :id="'exbonus_' + option.value"
                                            :value="option.value"
                                            v-model="formData.aube_coin_ex_bonus_setting"
                                            :disabled="disabled_flg && Number(formData.aube_coin_ex_bonus_setting) !== option.value"
                                        >
                                        <label
                                            :key="'exbonus_label_' + option.value"
                                            class="value-title"
                                            :for="'exbonus_' + option.value"
                                        >
                                            {{ $t(option.label) }}
                                        </label>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="text-center">
                    <div class="pb-4 ">
                        <button type="submit" class="btn btn-primary">{{ $t('hec.saving.btnConfirmText') }}</button>
                    </div>
                </div>
            </div>
        </form>
        </div>
    </template>

<script>
    import AubeCoinStakingService from '../../services/AubeCoinStakingService'
    import { AUBE_COIN_STAKING_ONE_YEARS_VALUE, AUBE_COIN_STAKING_TWO_YEARS_VALUE,
        AUBE_COIN_STAKING_THREE_YEARS_VALUE, AUBE_COIN_STAKING_FIVE_YEARS_VALUE, MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD
    } from '../../utils/Const'

    export default {
        name: 'aubeCoinAutomaticRemittance',

        data() {
            return {
                formData: this.getDefaultFields(),
                disabled_flg: false,
                memberTypeId: undefined,
                forthingOptions: [
                    { value: 1, label: 'aube-coin.staking.oneYearsLabel' },
                    { value: 2, label: 'aube-coin.staking.twoYearsLabel' },
                    { value: 3, label: 'aube-coin.staking.threeYearsLabel' },
                    { value: 5, label: 'aube-coin.staking.fiveYearsLabel' }
                ],
                exBonusOptions: [
                    { value: 1, label: 'aube-coin.staking.oneYearsLabel' },
                    { value: 2, label: 'aube-coin.staking.twoYearsLabel' },
                    { value: 3, label: 'aube-coin.staking.threeYearsLabel' },
                    { value: 5, label: 'aube-coin.staking.fiveYearsLabel' }
                ]
            }
        },

        async mounted() {
        },

        created() {
            this.fetchUserData();
        },

        computed: {
            showRemittanceBonusSetting() {
                if (this.memberTypeId === null || this.memberTypeId === undefined) {
                    return false;
                }
                const memberTypes = [MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD];
                return !memberTypes.includes(this.memberTypeId);
            }
        },

        methods: {
            getDefaultFields() {
                return {
                    aube_coin_forthing_setting: 1,
                    aube_coin_ex_bonus_setting: 1
                };
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                try {
                    sessionStorage.formData = JSON.stringify({
                        ...this.formData,
                        memberTypeId: this.memberTypeId
                    });
                    this.$router.push('/aube-coin-staking/automatic-remittance-confirm');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
            async fetchUserData() {
                try {
                    if (sessionStorage.formData) {
                        // sessionStorageに入力データが存在する場合入力データをデフォルト値に
                        this.selectData = JSON.parse(sessionStorage.formData);
                        this.formData.aube_coin_forthing_setting = this.selectData.aube_coin_forthing_setting;
                        this.formData.aube_coin_ex_bonus_setting = this.selectData.aube_coin_ex_bonus_setting;
                        this.memberTypeId = this.selectData.memberTypeId;
                    } else {
                        // sessionStorageに入力データが存在しない場合
                        // 既存データの存在チェック
                        const history_data = (await AubeCoinStakingService.getReserveAubeCoinStakingSettingHistory()).data;

                        this.memberTypeId = history_data.member_type_id;

                        if (history_data.forthing === null) {
                            // sessionStorageに入力データが存在せず、既存データも存在しない
                            this.formData.aube_coin_forthing_setting = AUBE_COIN_STAKING_ONE_YEARS_VALUE;
                            this.formData.aube_coin_ex_bonus_setting = AUBE_COIN_STAKING_ONE_YEARS_VALUE;
                        } else {
                            // 既存データが存在する場合は既存データをデフォルト値に
                            const validValues = [AUBE_COIN_STAKING_ONE_YEARS_VALUE, AUBE_COIN_STAKING_TWO_YEARS_VALUE, AUBE_COIN_STAKING_THREE_YEARS_VALUE, AUBE_COIN_STAKING_FIVE_YEARS_VALUE];

                            if (validValues.includes(Number(history_data.forthing.plan))) {
                                this.formData.aube_coin_forthing_setting = Number(history_data.forthing.plan);
                            } else {
                                // 不正な値の場合はデフォルト0を設定
                                this.formData.aube_coin_forthing_setting = AUBE_COIN_STAKING_ONE_YEARS_VALUE;
                            }

                            if (history_data.exbonus != null && validValues.includes(Number(history_data.exbonus.plan))) {
                                this.formData.aube_coin_ex_bonus_setting = Number(history_data.exbonus.plan);
                            } else {
                                this.formData.aube_coin_ex_bonus_setting = AUBE_COIN_STAKING_ONE_YEARS_VALUE;
                            }
                        }
                    }
                } catch (e) {
                    this.$router.push('/');
                }
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .setting-title{
        width: 160px;
        text-align: right;
    }
    .radio-box{
        vertical-align: middle;
    }
    .value-title{
        margin-bottom: 2px;
        margin-right: 10px;
        display: inline-block;
    }
    .value-space{
        margin-right: 5px;
    }
    .setting-radio{
        margin-left: 2px;
        margin-right: 2px;
        text-align:left;
    }
    .btn-primary {
        width: 115px;
        margin-top: 10px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }

    .flex{
        display: flex;
    }
    .colon{
        width: 20px;
    }
    .box {
        text-align:left;
        border-top-width: 0px;
    }
    .wrap {
        margin-left: auto;
    }
    .condition {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        max-width: unset;
        text-align: center;
    }

    .setting-box {
        justify-content: center;
        align-items: center;
        margin: 20px 0;
        text-align: center;
    }
    .left {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 10px;
        min-width: unset;
        width: auto;
    }

    @media (min-width: 992px){
        .col-lg-4 {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
    @media (min-width: 768px){
        .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
    @media (min-width: 576px){
        .col-sm-12 {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
</style>
